import { Box, Stack, Button, Tooltip, Typography, Drawer, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useHistory } from 'react-router-dom';
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol } from '../../../Utility/Constants'

export default function InsurancePackageConfig() {
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [packageList, setPackageList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

    useEffect(() => {
        getPackageData()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getPackageData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_INSURANCE_PACKAGE_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const Data = response.data.data?.map((item, index) => ({
                            ...item,
                            count: item?.data?.length || 0,
                            sno: index + 1,
                        }))
                        setPackageList(Data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id);

            let selectedRows = packageList.filter((row) => selectedIDs.has(row.id));

            let FinalData = selectedRows?.map((item) => item?.id)

            setdelIDs(FinalData);
        };

        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.02, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.api.getRowIndex(params.id) + 1}</Typography>)
            },
            {
                field: 'insurance_company_name', headerName: 'Insurance Name', flex: 0.25,
                renderCell: (params) => (params.row.insurance_company_name ? params.row.insurance_company_name?.length > 60 ?
                    <Tooltip placement="top" title={params.row.insurance_company_name}><Typography fontSize={'0.9vw'}>{params.row.insurance_company_name?.slice(0, 57) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.insurance_company_name}</Typography> : '-')
            },
            {
                field: 'config_type', headerName: 'Package Type', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.config_type ? params?.row?.config_type : '-'}</Box>)
            },
            {
                field: 'packagename', headerName: 'Package Name', flex: 0.15,
                renderCell: (params) => (params.row.packagename ? params.row.packagename?.length > 30 ?
                    <Tooltip placement="top" title={params.row.packagename}><Typography fontSize={'0.9vw'}>{params.row.packagename?.slice(0, 27) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.packagename}</Typography> : '-')
            },
            {
                field: 'total_amount', headerName: 'Total Amount', flex: 0.15, alignItems: "right",
                renderCell: (params) => (<Box component={'div'}>{params?.row?.total_amount > 0 ? AmountFormat(params?.row?.total_amount).replace(`${CurrencySymbol}`, "" ) : "0.00"}</Box>)
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => { history.push("/Settings/NewService/InsurancePackageConfig/Add", { insurance_name: params.row?.insurance_company_name, PackData: params.row?.id, PackType: params.row?.config_type }) }} />
                        </Stack>
                    </Stack>)
            },
        ]
        return (
            <Box sx={{ height: '70vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={packageList}
                    columns={columns}
                    getRowId={(row) => row['id']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const deletePackage = () => {
        try {
            setisloader(true)
            RestAPIService.delete(`${Serviceurls.NEW_INSURANCE_PACKAGE_MASTER}?ids=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getPackageData()
                        closeFilter();
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        {/* <Autocomplete
                            size='small'
                            options={department_category}
                            value={filtervendorCategory}
                            onChange={(event, newValue) => {
                                setFilterVendorCategory(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Vendor Catogory'}
                                />
                            )}
                        /> */}
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => { }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getPackageData();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '12vw', mt: "0.5vw", mb: "0.5vw" }} onClick={() => { history.push("/Settings/NewService/InsurancePackageConfig/Add") }}>ADD INSURANCE PACKAGE</Button>
            </Box>
            <Box component={'div'} sx={{ height: '70vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this item ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter}
                    removeData={deletePackage}
                />
                : null}
        </Box>
    )
}